import Vue from 'vue'
import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate3'
import en from 'vee-validate3/dist/locale/en.json'
import * as rules from 'vee-validate3/dist/rules'

// setInteractionMode('eager')

Object.keys(rules).map(rule => {
  extend(rule, rules[rule])
})

extend('double', value => {
  return !isNaN(value)
})

en.messages = {
  ...en.messages,
  alpha_num: 'The field may only contain alpha-numeric characters',
  email: 'The field must be a valid email',
  max_value: 'The field must be {max} or less',
  max: 'The field may not be greater than {length} characters',
  min_value: 'The field must be {min} or more',
  min: 'The field must be at least {length} characters',
  numeric: 'The field may only contain numeric characters',
  required: 'The field is required',
  confirmed: 'The confirmation password does not match'
}

localize('en', en)

// extend('required', required)
// extend('email', email)
// extend('min', min)
// extend('max', max)
// extend('numeric', numeric)
// extend('max_value', maxValue)

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
